import styled from "styled-components";

export const WrapperLabelHit = styled.div`
    &&{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-right: 5px;
    }
`

export const LabelHitBox = styled.span`
    &&{
        width: 30px;
        height: 19px;
        background-color: #0F4F9F;
        color: #fff;
        font-size: 12px;
        line-height: 19px;
        text-align: center;
        border : 1px solid #0F4F9F;
    }
`
export const LabelRankingBox = styled.span`
    &&{
        width: 50px;
        height: 19px;
        background-color: #fff;
        color: #0F4F9F;
        font-size: 12px;
        line-height: 19px;
        text-align: center;
        border : 1px solid #0F4F9F;
    }
`

export const LabelStock = styled.span`
    &&{
        display: inline-block;
        text-align: center;
        line-height: 17px;

        //box-sizing이 content-box인 경우와 border-box인 경우가 있어서 width, height를 설정할 때 주의해야 한다.
        width: ${(props) => props.labelWidth}px;
        height: ${(props) => props.labelHeight}px;

        border: 1px solid #418DED;
        color: #418DED;
        font-size: 12px;
        margin : ${(props) => props.margin ? props.margin : '0 5px 0 0'};
        visibility: ${(props)=> props.isShow ? 'visible' : 'hidden'};
        background-color: #fff;
        cursor: pointer;
        :hover{
            background-color: #f6f6f6;
        }
    }
`

export const LabelStdpc = styled.span`
    &&{
        display: inline-block;
        text-align: center;
        line-height: 17px;
        width : 56px;
        height: 19px;
        border: 1px solid #03868F;
        color: #03868F;
        font-size: 12px;
        margin : 0 5px 0 0;
        background-color: #fff;
    }
`

export const LabelEvent = styled.span`
    &&{
        display: inline-block;
        text-align: center;
        line-height: 17px;
        width : 46px;
        height: 19px;
        border: 1px solid #F47300;
        color: #F47300;
        font-size: 12px;
        margin : 0 5px 0 0;
        background-color: #fff;
    }
`



// WEBPACK FOOTER //
// ./src/estimate_list/common/label.style.js